import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import {
  ObtenerCorreosPrestadores,
  RedactarMensaje,
} from "src/app/shared/entrys/notificaciones-masivas.entry";

@Injectable()
export class NotificacionesCorreosMasivosService
  implements RequestCRUD<any, ResponseServiceModel>
{
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
    this.handleError = httpErrorHandler.createHandleError("CapacidadOperativa");
  }
  create(entry: any): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  get(entry: any): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  update(entry: any): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  redactarMensaje(entry: RedactarMensaje): Observable<HttpEvent<any>> {
    const input = new FormData();
    input.append("correo_electronico_pst", entry.correo_electronico_pst);
    input.append("prestador_id", entry.prestador_id);
    input.append("codigo_camara_pst", entry.codigo_camara_pst);
    input.append("asunto", entry.asunto);
    input.append("cuerpo", entry.cuerpo);
    input.append("nombre_pst", entry.nombre_pst);
    input.append("archivo", entry.file, entry.file.name);
    const uploadReq = new HttpRequest(
      "POST",
      `${this.API_URL}/NotificacionesMasivasAdministrador/RedactarMensaje`,
      input
    );

    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  redactarMensajeMasivo(entry: any): Observable<HttpEvent<any>>  {
    const input = new FormData();
    input.append("prestador_data_to_string", JSON.stringify(entry.prestador_data));
    input.append("asunto", entry.asunto);
    input.append("cuerpo", entry.cuerpo);
    input.append("archivo_base_64", entry.archivo_base_64);

    const uploadReq = new HttpRequest(
      "POST",
      `${this.API_URL}/NotificacionesMasivasAdministrador/RedactarMensajeMasivo`,
      input
    );

    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  delete(entry: any): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getCorreosPrestadores(
    entry: ObtenerCorreosPrestadores
  ): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/NotificacionesMasivasAdministrador/ObtenerCorreosPrestadores`,
        entry
      )
      .pipe(retry(2));
  }

  getCorreosPrestadoresTodos(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/NotificacionesMasivasAdministrador/ObtenerCorreosPrestadoresTodos?PageNumber=${entry.numeroPagina}&PageSize=100`,
        entry
      )
      .pipe(retry(2));
  }

  getMensajesEnviados(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/NotificacionesMasivasAdministrador/ObtenerMensajesEnviados?PageNumber=${entry.numeroPagina}&PageSize=12`,
        entry
      )
      .pipe(retry(2));
  }
}
